// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/TokensAndPots/ShoppingPremierToken.css
// module id = 3074
// module chunks = 0